import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from './../../services/app.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../models/user.model';
import { GenericModel } from '../../models/generic.model'
import { environment } from '../../../environments/environment';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { Branch } from 'src/app/models/branch.model';
import { Session } from 'src/app/models/session.model';
import { Router } from '@angular/router';
import { ParentService } from 'src/app/pages/parent/services/parent.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ToastNotificationService } from 'src/app/shared/services/toast-notify.service';
import { SubscriptionComponent } from './subscription.component';
import { SpinnerService } from 'src/app/shared/services/spinner.service';


@Component({
  selector: 'app-navbar-admin',
  templateUrl: './navbar-admin.component.html',
  styleUrls: ['./navbar-admin.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarAdminComponent implements OnInit {
  
  constructor(
    private appService: AppService,private userService: UserService,private modalService: NgbModal,
    private tokenStorageService: TokenStorageService, private router: Router,private configService: ConfigService,
    private parentService: ParentService,private spinnerService: SpinnerService,private toastNotifyService: ToastNotificationService,) {
  }

  modalRef: NgbModalRef;  
  isCollapsed = true;
  orgName: string;
  userDetail: GenericModel<User>;
  userId: string;
  profilePicUrl: string = '';
  branch: Branch;
  session: Session;
  sidebarPinned: boolean;

  ngOnInit() {
    console.log('*****NavbarAdminComponent****');
    let hostname = window.location.hostname; // get tenant i.e subdomain from "subdomain.domain.com"
    let tenant = ''
    if(hostname == 'localhost'){
      tenant = environment.defaultTenant
    }else{
      tenant= hostname.substring(0, hostname.indexOf('.'));
    }
    console.log(">>>>>Host Name:: "+hostname+' :tenant:>>>'+tenant);
    this.profilePicUrl = environment.authBase+environment.clientLogoUrl+tenant+'?X-TenantID='+tenant;  
    this.getBranchDetail();  
    this.getActiveSession();
  }

  getBranchDetail(){
    console.log('>>>>>getBranchDetail- navbar-admin>>>>> ')
    let branchCode = this.tokenStorageService.getBranchCode();
    let tenantName = this.tokenStorageService.getTenantName();
    this.userService.getBranchDetail(branchCode,tenantName).subscribe({
      next: (response: any) => {
        console.log(">>>getBranchDetail from service:navbar aadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.branch =  response.data;
          if(this.branch){
            this.tokenStorageService.saveBranchName(this.branch.branchName);
          } 
        }else if(response.status == environment.FAILURE){    
          console.log('!!! Failure response in getBranchDetail....')      
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error('!!! Error in getBranchDetail: ',e);          
      }
    });
  }
  getActiveSession(){
    console.log('>>>>>getActiveSession- navbar-admin>>>>> ')
    this.userService.getActiveSession().subscribe({
      next: (response: any) => {
        console.log(">>>getActiveSession from service:navbar aadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.session =  response.data;
          if(this.session){
            this.tokenStorageService.saveAcademicSession(this.session.sessionYear);
          }          
        }else if(response.status == environment.FAILURE){    
          console.log('!!! Failure response in getActiveSession....')      
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error('!!! Error in getBranchDetail: ',e);          
      }
    });
  }
  changeSession(){
    this.router.navigate(['admin/session']);
  }
  viewSubscriptionStatus(){
    console.log('----------viewSubscriptionStatus-----------------');
    this.spinnerService.showSpinner();
    let tenant = this.configService.getConfiguration().clientName; 
    console.log('tenant>>>>>>>'+tenant);
    this.parentService.getSubscribedFeatures(tenant).subscribe(
      res => {
        console.log('Tenant Detaisl>>>>>>>'+JSON.stringify(res.data));
        if(environment.SUCCESS == res.status){
          this.modalRef = this.modalService.open(SubscriptionComponent, { windowClass : "modal-holder", centered: false, size: 'md', backdrop:'static'});
          this.modalRef.componentInstance.tenantDetail = res.data;
          this.modalRef.componentInstance.modalRef = this.modalRef;
          
        }else if(environment.FAILURE == res.status){
          this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 10000);
        }
        this.spinnerService.hideSpinner();
      },
       error => {
        console.log('>>>>>error in getting subscription',error);
        setTimeout(() => {
          this.spinnerService.hideSpinner();
        }, 200);
      },
    );
    this.modalRef.result.then(() => {
      console.log('****viewSubscriptionStatus- modalref then******');
      //this.getStudentList();      
    });
  }
  toggleSidebarPin() {    
    this.appService.toggleSidebarPin();
    console.log('--------------toggleSidebarPin------------',this.appService.isSidebarPinned);
    this.sidebarPinned = this.appService.isSidebarPinned;
    
  }
  toggleSidebar() {
    console.log('--------------toggleSidebar------------');
    this.appService.toggleSidebar();
  }
}
